import { useState } from 'react';
import { debounceInComponent } from '../miscUtils';

import styles from './searchField.module.scss';

function SearchField({ updateSearchString }: any) {
  const [searchString, setSearchString] = useState('');

  const debouncedUpdate = debounceInComponent(updateSearchString, 250);

  const wrapperStyle: any = {};
  if (searchString) wrapperStyle.backgroundColor = 'var(--highlightTextBg)';

  return (
    <div className={styles.searchWrapper} style={wrapperStyle}>
      <input
        type="search"
        placeholder="Search"
        value={searchString}
        onChange={(ev) => {
          setSearchString(ev.target.value);
          debouncedUpdate(ev.target.value);
        }}
      />
    </div>
  );
}

export default SearchField;
